// @flow

import {getPropertyClasses} from './getPropertyClasses';
import {tableElements, tableRowName, tableCellName} from '../constants';

type GetCells = (params: {| tableId: string, rowIndex: number | string, nodeId: number, pinned: boolean |}) => {
    prevCell: ?HTMLElement,
    currentCell: ?HTMLElement,
} | null;

export const getCells: GetCells = ({tableId, rowIndex, nodeId, pinned}) => {
    const tableRight = document.getElementById(`${tableId}-right`);
    const allRows = tableRight ? tableRight.querySelectorAll(`${tableElements.body} .${tableRowName}`) : [];
    const index = [].indexOf.call(
        allRows,
        document.getElementById(`${tableId}${getPropertyClasses({pinned})}-row-${rowIndex}`)
    );

    if (index !== -1) {
        const prevCell = allRows[index - 1] ? allRows[index - 1].querySelector(`.${tableCellName}-${nodeId}`) : null;
        const currentCell = allRows[index].querySelector(`.${tableCellName}-${nodeId}`);

        return {
            prevCell,
            currentCell
        };
    }

    return null;
};
